import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    boxSizing: 'border-box',
    border: '1px dashed #aaa',
    width: '30px',
    height: '30px'
  },

  anchor: {
    height: '100%'
  },

  select: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: theme.size.sm
  },

  unpadLeft: {
    marginLeft: '10px'
  },

  button: {
    minWidth: 'unset',
    width: 'fit-content',
    paddingTop: '4px',
    paddingBottom: '4px',

    '&:last-child': {
      marginLeft: '0.5rem'
    }
  }
}))

export default useStyles
